webpackJsonp([263791100135453],{

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'I\'ve started my programming career back in the days of ASP.NET Webforms 2.0 and jQuery for the front-end. Since then I was following the .NET road upgrading to the new Webforms versions until the ASP.NET MVC came. '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I\'ve switched to MVC when the ASP.NET MVC 3 came out and I\'ve soon added the Web API.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'My latest change is with the front-end where I\'m starting to get in love with React.js and the Redux application architecture.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'As a developer I\'m respecting SOLID principles, I\'m using (and I want to continue using) IoC/DI, unit testing, continuous integration etc.'
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-25f757a1ed4fd2100b57.js